module.exports = __webpack_public_path__ + "static/media/MAAS-Payment.9b6ecf85.png";